import { createContext, useContext, type RefObject } from 'react'
import type { Map as MapLibreMap } from 'maplibre-gl'

export interface MapContextValue {
  mapRef: RefObject<MapLibreMap | null>
  flyTo: (lon: number, lat: number, zoom?: number) => void
  mapReady: boolean
}

export const MapContext = createContext<MapContextValue | null>(null)

export function useMapInstance(): MapContextValue {
  const ctx = useContext(MapContext)
  if (!ctx) throw new Error('useMapInstance must be used inside <AlertMap>')
  return ctx
}

export function useFlyTo() {
  const { flyTo } = useMapInstance()
  return flyTo
}
